module.exports = __webpack_public_path__ + "static/media/start-rotate-2.2f935ac3.png";